import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ROUTER_NAVIGATION, RouterNavigationAction } from '@ngrx/router-store';
import { AppState } from '../index';
import { select, Store } from '@ngrx/store';
import { catchError, distinctUntilChanged, filter, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { selectRouteParam, selectUrl } from './router.state';
import { ShipmentService } from '../../data/shipment.service';
import {
    shipmentEditorDisplayEditor,
    shipmentEditorLoadRequest,
    shipmentEditorLoadSuccess
} from '../shipment-editor/shipment-editor.actions';
import { ShipmentState } from '../../utils/shipment-state';
import { contactsTableChangeQuery } from '../contacts-table/contacts-table.actions';
import { selectContactsTableQuery } from '../contacts-table/contacts-table.state';
import { shipmentTableChangeQuery } from '../shipments-table/shipments-table.actions';
import { ShipmentStatusEnum } from '../../enum/shipment-status.enum';
import { interfaceSetRouteData } from '../interface/interface.actions';
import { ActivatedRouteSnapshot, ResolveEnd, Router } from '@angular/router';
import { Shipment } from '../../models/shipment';
import { selectShipmentEditorShipment } from '../shipment-editor/shipment-editor.state';

@Injectable()
export class RouterEffects {
    constructor(private actions$: Actions, private store: Store<AppState>, private shipmentService: ShipmentService,
                private router: Router) {}
/*
    loadShipmentOnRoute$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ROUTER_NAVIGATION),
            // extract ID param from router state
            map((r: RouterNavigationAction) => r.payload.routerState.root),
            map(this.getDeepestChild), // helper shown below
            filter(route => route.routeConfig?.path === 'shipment/:id'),
            map(route => route.params.id),
            distinctUntilChanged(),
            map(id => shipmentEditorLoadRequest({ id }))
        )
    );
*/

/*
    shipmentViewLoader$ = createEffect(() => this.actions$.pipe(
        ofType(ROUTER_NAVIGATION),
        withLatestFrom(this.store.pipe(select(selectRouteParam('id')))),
        withLatestFrom(this.store.pipe(select(selectUrl))),
        filter(([, url]) => url.startsWith('/shipment/')),
        switchMap(([[, id]]) => this.shipmentService.getByKey(id)),
        // filter((shipment) => ShipmentState.isQuotable(shipment.statusCode)),
        tap(() => this.store.dispatch(shipmentEditorDisplayEditor())),
        map(shipment => shipmentEditorLoadRequest({ id: shipment.id }))
    ));
*/
    shipmentBatchLoader$ = createEffect(() => this.actions$.pipe(
        ofType(ROUTER_NAVIGATION),
        filter((r: RouterNavigationAction) => !!r.payload.routerState.url.match(/\/batch\/\d+\/shipments/)),
        withLatestFrom(this.store.select(selectRouteParam('id'))),
        map(([ , id ]) => shipmentTableChangeQuery({
            query: {
                state: ShipmentStatusEnum.ANY,
                pageNumber: 1,
                itemsPerPage: null,
                sortColumn: null,
                sortDescending: null,
                afterDate: null,
                beforeDate: null,
                filter: null,
                courier: null,
                serviceId: null,
                shipper: [],
                destination: [],
                batchId: id
            }
        }))
    ));

    addressBookContacts$ = createEffect(() => this.actions$.pipe(
        ofType(ROUTER_NAVIGATION),
        tap(r => console.log('ROUTER_NAVIGATION', r)),
        filter((r: RouterNavigationAction) => !!r.payload.routerState.url.match(/\/addresses\/\d+\/contacts/)),
        withLatestFrom(this.store.select(selectRouteParam('id')), this.store.select(selectContactsTableQuery)),
        map(([ r, id, query ]) => contactsTableChangeQuery({
            query: {
                ...query,
                addressBookId: id,
                country: null,
                filter: null
            }
        }))
    ));

    routeData$ = createEffect(() => this.actions$.pipe(
        ofType(ROUTER_NAVIGATION),
        map((r: RouterNavigationAction) => r.payload.routerState.root),
        map(state => {
            let data = {};
            while (state.firstChild) {
                data = { ...data, ...state.firstChild.data };
                state = state.firstChild;
            }
            return data;
        }),
        map(routeData => interfaceSetRouteData({ routeData }))
    ));

    listenForResolver$ = createEffect(() =>
        this.router.events.pipe(
            filter((e): e is ResolveEnd => e instanceof ResolveEnd),
            map(e => {
                let node = e.state.root;
                while (node) {
                    const data = node.data as { shipment?: Shipment };
                    if (data.shipment) {
                        return data.shipment;
                    }
                    node = node.firstChild ?? null;
                }
                return null;
            }),
            filter((shipment): shipment is Shipment => !!shipment),
            withLatestFrom(this.store.select(selectShipmentEditorShipment)),
            filter(([shipment, existing]) => shipment.id !== existing?.id),
            map(([shipment]) => shipmentEditorLoadSuccess({ shipment }))
        )
    );



    private getDeepestChild(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
        while (route.firstChild) { route = route.firstChild; }
        return route;
    }

}
